import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrustInfoPageComponent } from './trust-info-page.component';

@NgModule({
  imports: [CommonModule, TrustInfoPageComponent],
  exports: [TrustInfoPageComponent],
})
export class TrustInfoPageModule {}
